import { render, staticRenderFns } from "./RepInformeNutricion.vue?vue&type=template&id=d4a1f8f6"
import script from "./RepInformeNutricion.vue?vue&type=script&lang=js"
export * from "./RepInformeNutricion.vue?vue&type=script&lang=js"
import style0 from "./RepInformeNutricion.vue?vue&type=style&index=0&id=d4a1f8f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports